import { Dropdown, Tooltip } from "antd";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import { existingAssetsTooltip } from "../../Utils/tooltipTexts";
import { newAssetsTooltip } from "../../Utils/tooltipTexts";
import { searchTooltip } from "../../Utils/tooltipTexts";
import { ExportExcelThunk, getSelectedAssetsThunk } from "../../Thunks";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { getExportedData } from "../../Reducer/ListeningReducer";

import { downloadExcel } from "../../Utils/ExportListing/ExportListing";
import { getCookie, setCookie } from "../../Utils/cookieshelper";

export const ListingSearchAndFilter = ({
  setIsModalOpen,
  setModalType,
  getSearchData,
  searchData,
  assets,
  selectedAlgorithm,
  setSelectedAlgorithm,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const customizeClick = () => {
    setIsModalOpen(true);
    setModalType("customizeAssets");
  };
  // const assets = useSelector(getSelectedAssets);
  const algorithms = [
    { key: 1, name: "New Assets", tooltip: newAssetsTooltip },
    { key: 2, name: "Existing Assets", tooltip: existingAssetsTooltip },
  ];

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const exportData = useSelector(getExportedData);

  useEffect(() => {
    dispatch(ExportExcelThunk());
  }, [assets]);

  const [visible, setVisible] = useState(false);

  const openAssetModal = () => {
    setModalType("assets");
    setIsModalOpen(true);
  };

  // On mount — load from cookies
  useEffect(() => {
    const savedAlgorithm = getCookie("selectedAlgorithm");
    if (savedAlgorithm) {
      setSelectedAlgorithm(savedAlgorithm);
    } else {
      setSelectedAlgorithm(algorithms[0]);
    }
  }, []);

  useEffect(() => {
    if (selectedAlgorithm?.key) {
      setCookie("selectedAlgorithm", selectedAlgorithm.name, 7);
      dispatch(getSelectedAssetsThunk(selectedAlgorithm.key));
    }
  }, [selectedAlgorithm]);

  const dropdownContent = (
    <div className="algorithm-dropdown-menu">
      {algorithms.map((algo) => (
        <div
          key={algo.name}
          className={`algorithm-dropdown-item ${
            selectedAlgorithm === algo.name ? "active" : ""
          }`}
          onClick={() => {
            setSelectedAlgorithm(algo);
            setIsDropdownOpen(false);
          }}
        >
          <span>{algo.name}</span>
          <Tooltip
            placement="leftTop"
            title={algo.tooltip}
            color="#364048"
            overlayInnerStyle={{
              width: "650px",
              height: "530px",
              overflow: "auto",
              transform: "translateX(-40px)",
            }}
            overlayClassName="custom-tooltip-position"
          >
            <i className="icon-Vector" style={{ paddingLeft: 10 }}></i>
          </Tooltip>
        </div>
      ))}
    </div>
  );
  return (
    <div className="listing_search_row">
      <div className="listening_search_wrapper">
        <div className="listening_search_icon_wrapper" />
        <input
          type="text"
          value={searchData}
          onChange={(e) => getSearchData(e.target.value)}
          className="listening_search_field"
          placeholder="Search..."
        />
        <Tooltip
          placement="rightTop"
          title={searchTooltip}
          color={"#364048"}
          onOpenChange={(visible) => setVisible(visible)}
        >
          <i
            className="icon-Vector"
            style={{ position: "relative", left: "10%", top: "8px" }}
          ></i>
        </Tooltip>
      </div>

      <div className="listing_export_customize_columns_wrapper">
        <Dropdown
          dropdownRender={() => dropdownContent}
          trigger={["click"]}
          overlayClassName="algorithm-dropdown-overlay"
          open={isDropdownOpen}
          onOpenChange={(open) => setIsDropdownOpen(open)}
        >
          <button
            className={`listing_customize listing_score_algorithm ${
              isDropdownOpen ? "ant-dropdown-open" : ""
            }`}
          >
            <span style={{ fontWeight: "bold", opacity: "1" }}>
              {getCookie("selectedAlgorithm") ?? selectedAlgorithm?.name}
            </span>
            <Tooltip
              placement="leftTop"
              title={selectedAlgorithm?.tooltip}
              color="#364048"
              overlayInnerStyle={{
                width: "650px",
                height: "530px",
                overflow: "auto",
                transform: "translateX(-40px)",
              }}
              overlayClassName="custom-tooltip-position"
            >
              <i
                className="icon-Vector"
                style={{ zIndex: 11, fontSize: "16px" }}
              ></i>
            </Tooltip>
            {isDropdownOpen ? <UpOutlined /> : <DownOutlined />}
          </button>
        </Dropdown>

        <div className="listing_export_customize_columns_wrapper">
          <button
            className="listing_customize listing_saveUs"
            onClick={() => downloadExcel()}
          >
            <i className="icon-export"></i>
            <span>Export</span>
          </button>

          <button
            className="listing_customize"
            onClick={customizeClick}
            style={{ gap: "4px" }}
          >
            <i className="icon-customize listing_customize_icon"></i>
            {/* <img
              src={CustomizeIcon}
              alt="Customize"
              className="listing_customize_icon"
            /> */}

            <span>Assets</span>
          </button>

          <button
            className="listing_customize"
            onClick={() => navigate("/statistics")}
          >
            <i className="icon-statistics"></i>
            <span>Analytics</span>
          </button>
        </div>
      </div>
    </div>
  );
};
